module.exports = __webpack_public_path__ + "assets/media/day26.95b3753c.mp3";